import React, { useState, useEffect } from "react";
import {
    Grid,
    Typography,
    TextField,
    Button,
    Collapse,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import axios from "axios";
import usePersonAuthStore from "../../../store/personAuthStore";
import { useNavigate } from "react-router";

interface LoginProps {
    onSuccess: (data: string) => void;
}

function Login({ onSuccess }: LoginProps) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [showError, setShowError] = useState(false)

    const navigate = useNavigate();

    const setPersonAuthToken = usePersonAuthStore(state => state.setAuthValues);

    const handleChange = (name: string) => (evt: React.ChangeEvent<HTMLInputElement>): void => {
        setShowError(false)
        if (name === "password") {
            setPassword(evt.target.value);
        } else {
            setUsername(evt.target.value);
        }
    };


    const handleSubmit = (evt: React.FormEvent<HTMLFormElement>) => {

        evt.preventDefault();

        setSubmitting(true);
        const formData = new FormData();
        formData.append("username", username.trim());
        formData.append("password", password.trim());
        formData.append("grantType", "password");

        axios
            .post(`${window.__env.API_URL}/api/oauth/authenticate`,
                formData, {
                withCredentials: true,
                headers: {
                    // need to work in firefox
                    "access-control-allow-origin": "*"
                }
            })
            .then((res: any) => {
                if (res.data.message === "Dual Auth Needed") {
                    onSuccess(res.data.tempId)
                } else if (res.data.message === "Password expired") {
                    setPersonAuthToken(res.data)
                    navigate(`/password-expired/${res.data.tempId}`)
                }
                else if (res.data.message === "Successfully signed in") {
                    setPersonAuthToken(res.data);
                    navigate("/dashboard", { replace: true })
                }

            })
            .catch(function (error) {
                if (error.response) {
                    const status = JSON.parse(error.request.response)?.response_type
                    const message = JSON.parse(error.request.response)?.message
                    if (status == "LockedOut") {
                        setError(message)
                    } else {
                        setError("Login failed. Email or password is incorrect");
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    setError("Connection refused. Please try again later");
                } else {
                    // Something happened in setting up the request that triggered an Error
                    setError("Connection refused. Please try again later");
                }
                setSubmitting(false);
                setShowError(true)
            });
    };

    // if (accessToken)
    //   return <Redirect to="/dashboard" />

    return (
        <Grid container spacing={2}>
            <Grid
                size={12}
                style={{
                    marginTop: "40px",
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "center",
                }}
            >
                <div
                    style={{
                        height: "175px",
                        width: "500px",
                        objectFit: "cover",
                        background: `url(${process.env.PUBLIC_URL}/assets/images/logos/FT_logo_1.png)`,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                    }}
                ></div>
            </Grid>
            <Grid
                size={12}
                style={{
                    height: "400px",
                    padding: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2} style={{ maxWidth: "400px" }}>
                        <Grid size={12}>
                            <TextField
                                label="Username"
                                value={username}
                                onChange={handleChange("username")}
                                fullWidth
                            />
                        </Grid>
                        <Grid size={12}>
                            <TextField
                                type="password"
                                label="Password"
                                value={password}
                                onChange={handleChange("password")}
                                fullWidth
                            />
                        </Grid>
                        {/* <Grid size={12} sx={{ display: "flex", justifyContent: "space-between", }}>
                            <Button color="secondary" onClick={() => navigate("/forgot-password")}> Forgot your password?</Button>
                            <Button color="secondary" onClick={() => window.location.href = 'https://docs.google.com/document/d/1yxYn4hU786eKJkh-lZN0FecDROKep2fJIo4apixsHik/edit?usp=sharing'}>Troubleshooting</Button>

                        </Grid> */}
                        <Grid size={6} style={{ textAlign: 'center' }}>
                            <Button color="secondary" onClick={() => navigate("/forgot-password")}> Forgot password?</Button>
                        </Grid>
                        <Grid size={6} style={{ textAlign: 'center' }}>
                            <Button color="secondary" onClick={() => window.location.href = 'https://docs.google.com/document/d/1yxYn4hU786eKJkh-lZN0FecDROKep2fJIo4apixsHik/edit?usp=sharing'}>Troubleshooting</Button>
                        </Grid>
                        <Grid size={12} style={{ textAlign: 'center' }}>
                            <Collapse in={showError} sx={{ marginBottom: "22px" }}>
                                <Typography color="error">{error}</Typography>
                            </Collapse>
                            {submitting ? (
                                <LoadingButton
                                    loading={submitting}
                                    // sx={{ marginTop: "32px" }}
                                    variant="contained"
                                >
                                    Login
                                </LoadingButton>
                            ) : (
                                <Button
                                    type="submit"
                                    variant="contained"
                                    disabled={!Boolean(password && username)}
                                // sx={{ marginTop: "22px" }}
                                >
                                    Login
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </form>
            </Grid>
        </Grid>
    );
}

export default Login;
